
import React from 'react';
import apiBaseUrl from '../config/api';
import './PurchasePage.css';

// Razorpay script loader
function loadRazorpayScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

// PAYMENT_OPTIONS removed (was unused)

const initialForm = {
  customerName: '',
  customerEmail: '',
  customerPhone: '',
  paymentMethod: 'upi',
};

const PurchasePage = ({ prefillEmail = '', onBackHome }) => {
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);
  const [form, setForm] = React.useState({ ...initialForm, customerEmail: prefillEmail });
  const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;
  const [, setBook] = React.useState(null); // book state removed (was unused)
  const [loadingBook, setLoadingBook] = React.useState(true);
  const [placingOrder, setPlacingOrder] = React.useState(false);
  const [error, setError] = React.useState('');
  const [orderSuccess, setOrderSuccess] = React.useState(null);

  React.useEffect(() => {
    let cancelled = false;

    const loadBook = async () => {
      setLoadingBook(true);
      try {
        const featuredRes = await fetch(`${apiBaseUrl}/products/featured`);
        const featuredData = await featuredRes.json();
        const featuredBook = Array.isArray(featuredData) && featuredData.length > 0 ? featuredData[0] : null;

        if (!cancelled && featuredBook) {
          setBook(featuredBook);
          return;
        }

        const fallbackRes = await fetch(`${apiBaseUrl}/products?limit=1&offset=0`);
        const fallbackData = await fallbackRes.json();
        if (!cancelled) {
          setBook(Array.isArray(fallbackData) && fallbackData.length > 0 ? fallbackData[0] : null);
        }
      } catch (_) {
        if (!cancelled) {
          setBook(null);
        }
      } finally {
        if (!cancelled) {
          setLoadingBook(false);
        }
      }
    };

    loadBook();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const validate = () => {
    return '';
  };

  // Razorpay payment handler (with backend order creation and verification)
  const handleRazorpayPayment = async () => {
    const validationMessage = validate();
    if (validationMessage) {
      setError(validationMessage);
      return;
    }
    setPlacingOrder(true);
    setError('');
    const sdkLoaded = await loadRazorpayScript('https://checkout.razorpay.com/v1/checkout.js');
    if (!sdkLoaded) {
      setError('Failed to load Razorpay SDK.');
      setPlacingOrder(false);
      return;
    }
    // 1. Create order on backend
    let orderRes;
    try {
      orderRes = await fetch(`${apiBaseUrl}/payment/razorpay-order`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount: 14900, customerPhone: form.customerPhone }),
      });
    } catch (err) {
      setError('Could not initiate payment.');
      setPlacingOrder(false);
      return;
    }
    const orderData = await orderRes.json();
    if (!orderRes.ok || !orderData.orderId) {
      setError('Could not create payment order.');
      setPlacingOrder(false);
      return;
    }
    // 2. Open Razorpay checkout with callback_url
    const options = {
      key: RAZORPAY_KEY_ID,
      amount: orderData.amount, // Use backend-provided amount
      currency: orderData.currency || 'INR',
      name: 'Business Idea Hub',
      description: 'Top 50 Online Business Ideas eBook',
      order_id: orderData.orderId,
      handler: function (response) {
        alert(response.razorpay_payment_id);
        alert(response.razorpay_order_id);
        alert(response.razorpay_signature);
        // Send success details to backend for logging
        fetch(`${apiBaseUrl}/payment/razorpay-success`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(response),
        });
      },
      prefill: {
        name: form.customerName,
        email: form.customerEmail,
        contact: form.customerPhone,
      },
      notes: {
        address: form.shippingAddress,
      },
      theme: {
        color: '#0f5fb4',
      },
    };
    const rzp = new window.Razorpay(options);
    rzp.on('payment.failed', function (response) {
      alert(response.error.code);
      alert(response.error.description);
      alert(response.error.source);
      alert(response.error.step);
      alert(response.error.reason);
      alert(response.error.metadata.order_id);
      alert(response.error.metadata.payment_id);
      // Send failure details to backend for logging
      fetch(`${apiBaseUrl}/payment/razorpay-failure`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(response),
      });
    });
    rzp.open();
    setPlacingOrder(false);
  };

  if (orderSuccess) {
    return (
      <section className="purchase-page">
        <div className="purchase-shell success">
          <h2>Payment Successful</h2>
          <p>Your order has been placed successfully.</p>
          <p><strong>Amount Paid:</strong> Rs. {Number(orderSuccess.totalAmount || 0).toLocaleString('en-IN')}</p>
          <button type="button" className="purchase-btn" onClick={onBackHome}>Back to Home</button>
        </div>
      </section>
    );
  }

  return (
    <section className="purchase-page">
      <div className="purchase-shell">
        <div className="purchase-header">
          <h1>Complete Your Purchase</h1>
          <p>Get instant access to the Top 50 Online Business Ideas e-book.</p>
        </div>

        <div className="purchase-layout">
          <aside className="purchase-summary">
            <h3>Your Order</h3>
            {loadingBook ? (
              <p>Loading e-book details...</p>
            ) : (
              <>
                <p className="book-name">eBook</p>
                <p className="book-price">Rs. 149</p>
              </>
            )}
          </aside>

          <form className="purchase-form" onSubmit={e => e.preventDefault()}>
            <label>
              Full Name
              <input value={form.customerName} onChange={(e) => handleChange('customerName', e.target.value)} placeholder="Enter full name" />
            </label>

            <label>
              Email
              <input type="email" value={form.customerEmail} onChange={(e) => handleChange('customerEmail', e.target.value)} placeholder="Enter email" />
            </label>

            <label>
              Phone
              <input value={form.customerPhone} onChange={(e) => handleChange('customerPhone', e.target.value)} placeholder="Enter phone number" />
            </label>



            {error && <p className="purchase-error">{error}</p>}

            <button
              type="button"
              className="purchase-btn"
              style={{ display: 'inline-block', background: '#0f5fb4', color: '#fff', marginBottom: 12, textAlign: 'center', textDecoration: 'none', padding: '12px 32px', borderRadius: '8px', fontWeight: 700, fontSize: '1.1rem' }}
              onClick={handleRazorpayPayment}
              disabled={placingOrder}
            >
              {placingOrder ? 'Processing...' : 'Pay with Razorpay (UPI/Card/Netbanking)'}
            </button>

          </form>
        </div>
      </div>
    </section>
  );
};

export default PurchasePage;
